export const FIELD_MAPPINGS = {
  period: 'periodName',
  tagname: 'tagName',
  description: 'description',
  subtag: 'subTagName',
  view: 'catView',
  defaulttag: 'defaultTag',
};

export const MIN_COLUMNS_NUMBER = 6;

export const MAX_COLUMNS_NUMBER = 6;

export const SHEET_NAME = 'Tags';

export const IMPORT_RANGE_LAST_COLUMN = 'F';
